module.exports = __webpack_public_path__ + "img/bg04.789f4a6c.gif";